import * as React from "react";
import type { SVGProps } from "react";
const SvgPaymentCardWithCoins = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.28 16.11h-.01c.237 0 .473-.03.71-.09l5.19-1.393A3 3 0 0 0 11 17c0 1.65 1.35 3 3 3 .77 0 1.476-.294 2.008-.776A3.01 3.01 0 0 0 19 22c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.77 0-1.476.294-2.008.776a3.013 3.013 0 0 0-2.587-2.749l3.605-.967a2.764 2.764 0 0 0 1.96-3.39l-.957-3.581a1.024 1.024 0 0 0-.06-.225L18.47 4.06a2.76 2.76 0 0 0-3.39-1.96L4.05 5.05c-.71.19-1.31.65-1.68 1.29a2.71 2.71 0 0 0-.27 2.1l1.5 5.62a2.794 2.794 0 0 0 2.67 2.05h-.01.02ZM16.54 4.56l.26.97L4.277 8.886 4.02 7.92a.79.79 0 0 1 .08-.58.77.77 0 0 1 .47-.36L15.6 4.03c.07-.03.13-.03.2-.03v-.01c.34 0 .65.23.74.57ZM4.794 10.814 17.315 7.46l.725 2.711c.05.19.02.4-.08.58a.77.77 0 0 1-.47.36L6.46 14.07a.77.77 0 0 1-.94-.54l-.726-2.716ZM18 19c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1Zm-4-3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 18.5a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Zm2 0c0-.28.22-.5.5-.5s.5.22.5.5-.22.5-.5.5-.5-.22-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaymentCardWithCoins;
